import { Unionize } from 'utilitys/helpers/TsGeneral';
import { StateCreator, create } from 'zustand';

interface Props {
    dateFilter: ISelectOption<string>;
    update: (value: Unionize<Omit<Props, 'update'>>) => void;
}

const state: StateCreator<Props> = (set) => ({
    dateFilter: {
        label: 'All Months',
        value: 'All Months',
    },
    update: (value) => set({ ...value }),
});
export const useProgramCriticalAnalysisStore = create(state);
